module.exports = __webpack_public_path__ + "41913b77bab9f4d39683c7f71f9b793b.obj";